import classNames from "classnames";
import { forwardRef } from 'react';
import PropTypes from 'prop-types';


let defaultElement = "section";

/**
 * It takes a size and a direction and returns a string that can be used as a CSS grid template.
 * @param [size=0-12] - The number of columns or rows you want to create.
 * @param [direction] - "row" or "col"
 * @returns A string that is a template literal.
 */
const generateGridTemplate = (size = 0, direction = "") => {
  if (direction.includes("reverse") || !["row", "col"].includes(direction)) return;
  return `grid-${direction}s-${size}`
}


/**
 * It takes a size and a direction and returns a string that can be used as a Tailwind CSS grid
 * template for large screens.
 * @param [size=0] - The number of columns or rows you want to have.
 * @param [direction] - row or col
 * @returns A string.
 */
const generateGridTemplateLg = (size = 0, direction = "") => {
  if (direction.includes("reverse") || !["row", "col"].includes(direction)) return;
  return `lg:grid-${direction}s-${size}`
}

/**
 * It takes a size and a direction and returns a string that can be used as a Tailwind CSS grid
 * template for medium screens.
 * @param [size=0] - The number of columns or rows you want to have.
 * @param [direction] - row or col
 * @returns A string.
 */
const generateGridTemplateMd = (size = 0, direction = "") => {
  if (direction.includes("reverse") || !["row", "col"].includes(direction)) return;
  return `md:grid-${direction}s-${size}`
}

/**
 * It takes a string as an argument and returns a string.
 * @param [direction] - The direction of the flexbox.
 */
const generateFlexTemplate = (direction = "") => {
  if(!["row", 'col', 'reverse'].includes(direction)) return;
  return `flex-${direction}`
}

const Container = forwardRef((props, ref) => {
  const { as, display, sm, md, lg, xl, direction, noGutter, className, ...rest } = props;

  const Component = as ? as : defaultElement;

  const Display = {
    flex: "flex",
    grid: "grid"
  };


  const classes = classNames(className, {
    "px-4 lg:px-8": !noGutter,
    [Display[display]]: display,
    [generateGridTemplate(sm, direction)]: direction && display === "grid",
    [generateFlexTemplate(direction)]: direction && display === "flex",
    [generateGridTemplateMd(md, direction)]: md,
    [generateGridTemplateLg(lg, direction)]:lg
  })

  return (
    <Component ref={ref} {...rest} className={classes} />
  )
});

Container.propTypes = {
  as: PropTypes.element,
  display: PropTypes.oneOf(["flex", "grid"]),
  size: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  noGutter: PropTypes.bool,
}

Container.defaultProps = {

}

export default Container;